const types = {
	CHANGE_CURRENT_PAGE_TYPE: 'CHANGE_CURRENT_PAGE_TYPE',
	CHANGE_LOGIN_STATUS: 'CHANGE_LOGIN_STATUS', // 登录状态
	CHANGE_USERINFO: 'CHANGE_USERINFO',
	CHANGE_CLIENTS: 'CHANGE_CLIENTS',
	CHANGE_USERINIT: 'CHANGE_USERINIT',
	CHANGE_ALL_THEMES: 'CHANGE_ALL_THEMES', // 全部显示设置
	CHANGE_CURRENT_THEME: 'CHANGE_CURRENT_THEMES', // 全部显示设置
	CHANGE_CURRENT_FAVOR: 'CHANGE_CURRENT_FAVOR', // 简约模式或者颜色模式
	CHANGE_USER_LANG: 'CHANGE_USER_LANG', // 用户多语言
};

export default types;
